import React, { Component } from 'react';
import Select from "react-select";
import './addProductMapping.less';
import { debounce } from '../../../../utils/index.js';
import Cx from "classnames";

class AddProductMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      row: props.row,
      debouncedGetProductData: null
    };
    
    // Initialize debounced function
    this.debouncedGetProductData = debounce(this.props.getProductData, 500);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.row !== this.props.row) {
      this.setState({ row: this.props.row });
    }
  }

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  handleSave = () => {
    const { onSave } = this.props;
    const { row } = this.state;
    if (onSave) onSave(row);
  };

  handleUpdate = () => {
    const { handleUpdate } = this.props;
    const { row } = this.state;
    handleUpdate(row);
  }

  handleCellChange = (key, option) => {
    this.setState((prev) => ({
      row: { ...prev.row, product: option.material_name, product_code: option.product }
    }));
  };

  handleAcceptedProductChange = (productIndex, key, value) => {
    this.setState((prev) => {
      const updatedAcceptedList = [...(prev.row.accepted_product_list || [])];
      if (updatedAcceptedList[productIndex]) {
        if(key === 'product') {
            updatedAcceptedList[productIndex] = { ...updatedAcceptedList[productIndex], product: value?.material_name, product_code: value?.product }
        } else {
            updatedAcceptedList[productIndex] = { ...updatedAcceptedList[productIndex], [key]: value };
        }
      }
      return {
        row: { ...prev.row, accepted_product_list: updatedAcceptedList }
      };
    });
  };

  addAcceptedProduct = () => {
    this.setState((prev) => {
      const newAcceptedProduct = {
        product: '',
        product_code: '',
        is_pharma: false
      };
      return {
        row: {
          ...prev.row,
          accepted_product_list: [...(prev.row.accepted_product_list || []), newAcceptedProduct]
        }
      };
    });
  };

  removeAcceptedProduct = (productIndex) => {
    this.setState((prev) => {
      const updatedAcceptedList = [...(prev.row.accepted_product_list || [])];
      updatedAcceptedList.splice(productIndex, 1);
      return {
        row: { ...prev.row, accepted_product_list: updatedAcceptedList }
      };
    });
  };

  buildSelectOptions = (options) => {
    return (options || []).map(opt => {
      if (opt && typeof opt === 'object') {
        const value = opt.product ?? opt.id ?? opt.code ?? '';
        const label = opt.material_name ?? opt.name ?? String(value);
        return { value, label };
      }
      return { value: opt, label: opt };
    });
  };

  renderAcceptedProductRow = (acceptedProduct, productIndex) => {
    const { productOptions, isEdit } = this.props;
    const pharmaOpts = [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' }
    ];

    let selectedProduct = (productOptions || []).find(opt => opt.product === acceptedProduct.product);
    if(!selectedProduct && isEdit && acceptedProduct.product) {
      selectedProduct = {
        material_name: acceptedProduct.product,
        product: acceptedProduct.product_code
      }
    }
    const selectedPharma = pharmaOpts.find(opt => opt.value === acceptedProduct.is_pharma);

    return (
      <tr key={`accepted-${productIndex}`} className="pm-accepted-product-row">
        <td className="pm-col">
          <Select
            className="pm-select"
            classNamePrefix="select"
            options={productOptions}
            getOptionLabel={(option) => option.material_name}
            getOptionValue={(option) => option.product}
            value={selectedProduct}
            onChange={(option) => this.handleAcceptedProductChange(productIndex, 'product', option || '')}
            placeholder="Select Product"
            isSearchable={true}
            isClearable={true}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 99999
              })
            }}
            onInputChange={(value) => {
              if (value.length > 3) {
                this.debouncedGetProductData(value);
              }
              return value;
            }}
          />
        </td>
        <td className="pm-col pm-col--center">
          <Select
            className="pm-select"
            classNamePrefix="select"
            value={selectedPharma}
            options={pharmaOpts}
            onChange={(option) => this.handleAcceptedProductChange(productIndex, 'is_pharma', option?.value || false)}
            placeholder="Select"
          />
        </td>
        <td className="pm-col pm-col--action">
          <div className="pm-action-buttons">
            <button 
              className="pm-add-icon-btn" 
              onClick={() => this.addAcceptedProduct()}
              type="button"
              title="Add Accepted Product"
            >
              +
            </button>
            <button 
              className="pm-remove-btn" 
              onClick={() => this.removeAcceptedProduct(productIndex)}
              type="button"
              title="Remove Product"
            >
              ×
            </button>
          </div>
        </td>
      </tr>
    );
  };

  renderMainRow = () => {
    const { productOptions, isEdit } = this.props;
    const { row } = this.state;
    let selectedProduct = (productOptions || []).find(opt => opt.value === row.product);
    if(!selectedProduct && isEdit && row.product) {
      selectedProduct = {
        material_name: row.product,
        product: row.product_code
      }
    }
    const acceptedProductCount = row.accepted_product_list ? row.accepted_product_list.length : 0;
    const rowSpan = Math.max(1, acceptedProductCount + 1); // +1 for the main row itself

    return (
      <tr key="main-row" className="pm-main-row">
        <td className="pm-col pm-col--name" rowSpan={rowSpan}>
          <Select
            className={Cx("pm-select", {
              'NotSelectablediv': isEdit
            })}
            classNamePrefix="select"
            options={productOptions}
            getOptionLabel={(option) => option.material_name}
            getOptionValue={(option) => option.product}
            value={selectedProduct}
            onChange={(option) => this.handleCellChange('product', option || '')}
            placeholder="Select Product"
            isSearchable={true}
            isClearable={true}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 99999
              })
            }}
            onInputChange={(value) => {
              if (value.length > 3) {
                this.debouncedGetProductData(value);
              }
              return value;
            }}
            disabled={true}
          />
        </td>
      </tr>
    );
  };

  validateFields = () => {
    const { row } = this.state;
    if (!row?.product || !row?.product_code) {
      return false;
    }
    const invalidItem = (row.accepted_product_list || []).some(
      el => !el?.product || !el?.product_code
    );
  
    if (invalidItem) {
      return false;
    }
  
    return true;
  };

  render() {
    const { isOpen, title, isEdit } = this.props;
    const { row } = this.state;
    if (!isOpen) return null;

    return (
      <div className="add-user-wrap">
        <div className="overlay" onClick={this.handleClose}></div>
        <div id="modal" className="modal-popup pm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="pop-heading">{title || 'Product Mapping'}</div>
          <div className="content">
            <div className="product-mapping-table">
              <table className="pm-table" style={{marginTop: '0px', marginBottom: '50px'}}>
                <thead>
                  <tr className="pm-row pm-row--header">
                    <th className="pm-col pm-col--name">Product</th>
                    <th className="pm-col">Accepted Product</th>
                    <th className="pm-col pm-col--center">Pharma</th>
                    <th className="pm-col pm-col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderMainRow()}
                  {row.accepted_product_list && row.accepted_product_list.map((acceptedProduct, productIndex) => 
                    this.renderAcceptedProductRow(acceptedProduct, productIndex)
                  )}
                </tbody>
              </table>
            </div>

            <div className="submit-section submit-area pm-actions">
              <div className="button-section">
                {isEdit ? 
                  <div className={Cx("add-button", {
                    'disabled': !this.validateFields()
                  })} onClick={this.handleUpdate}>Update</div> :
                  <div className={Cx("add-button", {
                    'disabled': !this.validateFields()
                  })} onClick={this.handleSave} disabled>Save</div>
                }
              </div>
              <div className="button-section">
                <div className="add-button discard" onClick={this.handleClose}>Close</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddProductMapping;
